module.exports = __webpack_public_path__ + "static/media/me.639b02ee.jpg";